import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import AdminDashboardMenu from './admin_dashboard_menu';
import AdminDashboardProposalsSearchForm from './proposals_search/admin_dashboard_proposals_search_form';

export class AdminDashboard extends Component {
  static propTypes = {
    user: PropTypes.object.isRequired,
    userSettingValues: PropTypes.array.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = { adminProposals: null };
  }

  onResults = (adminProposals) => {
    this.setState({ adminProposals });
  };

  render() {
    const { user, userSettingValues } = this.props;

    const { onResults } = this;

    return (
      <div className="admin-dashboard content">
        <div className="row">
          <h1>Admin Dashboard</h1>
          <AdminDashboardProposalsSearchForm {...{ onResults }} />
        </div>

        <div className="row">
          <AdminDashboardMenu {...{ user, userSettingValues }} />
        </div>
      </div>
    );
  }
}

const ConnectedAdminDashboard = connect(({ user, userSettingValues }) => ({ user, userSettingValues }))(AdminDashboard);

export default ConnectedAdminDashboard;
